export default function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-zoom/src/event.js
// module id = 482
// module chunks = 0 1 2 3 4